// @flow

import { useDispatch } from 'react-redux';

import { createLogger } from 'redux-logger';

import {
  getCart,
  removeCartProducts,
  selectCartIsWorking,
  type ProductId,
} from '@gandi/cart';

import { useAppSelector } from 'src/hooks';

const logger = createLogger('useRemoveCartMailboxes');

export function useRemoveCartMailboxes(): {
  handleRemoveCartMailboxes: (ids: Array<ProductId>) => Promise<void>,
  isRemovingMailboxes: boolean,
} {
  const dispatch = useDispatch();

  const isRemovingMailboxes = useAppSelector(selectCartIsWorking);

  async function handleRemoveCartMailboxes(ids: Array<ProductId>) {
    try {
      await dispatch(removeCartProducts(ids.map(id => ({ id }))));
      dispatch(getCart());
    } catch (err) {
      dispatch(
        logger.warn({ err }, 'Unable to remove mailboxes from the cart.'),
      );
      throw err;
    }
  }

  return { handleRemoveCartMailboxes, isRemovingMailboxes };
}
